import {
    GET_STAFF_NOTIFICATIONS_COUNT,
    GET_STAFF_NOTIFICATIONS,
    LOAD_MORE_STAFF_NOTIFICATIONS,
    SET_STAFF_NOTIFICATIONS_PAGES,
    STAFF_NOTIFICATION_ERROR,

} from "../../actions/staffNotification/staffNotification";

const initialState = {
    count: null,
    notifications: [],
    error: null,
};

const staffNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STAFF_NOTIFICATIONS_COUNT:
            return { ...state, count: action.payload, error: null };
        case GET_STAFF_NOTIFICATIONS:
            return { ...state, notifications: action.payload, error: null };
        case LOAD_MORE_STAFF_NOTIFICATIONS:
            return {
                ...state,
                notifications: [...state.notifications, ...action.payload],
                error: null,
            };
        case STAFF_NOTIFICATION_ERROR:
            return { ...state, error: action.payload };
        case SET_STAFF_NOTIFICATIONS_PAGES:
            return { ...state, totalPages: action.payload };
        default:
            return state;
    }
};

export default staffNotificationReducer;